module.exports = __webpack_public_path__ + "static/media/SING-RMIT-SG.d4dd69c7.png";